import IInitializableModule from '@episerver/spa-core/Core/IInitializableModule';
import IServiceContainer from '@episerver/spa-core/Core/IServiceContainer';
import IEpiserverContext from '@episerver/spa-core/Core/IEpiserverContext';
import IStateReducerInfo from '@episerver/spa-core/Core/IStateReducerInfo';
import routingReducer from './routingSlice';
import {loadStateFromHistory} from '../stateUtils';

export default class RoutingInitializableModule implements IInitializableModule {
  protected name: string = 'Routing module';

  public GetName(): string {
    return this.name;
  }

  public ConfigureContainer(container: IServiceContainer): void {
    //No action taken by default
  }

  public StartModule(context: IEpiserverContext): void {
    const resetApp = () => {
      const currState = context.getStore().getState();
      let state = loadStateFromHistory(`${window.location.pathname + window.location.search}::${window.location.hash}`);
      if (state) {
        /* AUTHENTICATION RESTORATION */
        state.authentication = currState.authentication;
        state.otp = currState.otp;
        /* ABROAD */
        state.cellcomAbroad.otpPhoneForm = currState.cellcomAbroad.otpPhoneForm;
        state.cellcomAbroad.otpCodeForm = currState.cellcomAbroad.otpCodeForm;
        state.cellcomAbroad.otpData = currState.cellcomAbroad.otpData;
        /* ABROAD */
        /* AUTHENTICATION RESTORATION */

        context.dispatch({type: 'RESET_APP', payload: state});
      }
    };

    resetApp();

    if (typeof window !== 'undefined') {
      window.addEventListener('popstate', () => {
        resetApp();
      });
    }

    if (context.isDebugActive()) {
      console.debug(`Starting ${this.GetName()}`);
    }
  }

  public GetStateReducer(): IStateReducerInfo<any> | null {
    return {
      stateKey: 'routing',
      reducer: routingReducer,
    };
  }
}
